import React, { useState, useEffect } from "react";
import CardLayout from "../../../../common/cardLayout/CardLayout";
import moment from "moment-timezone";
import { useSelector } from "react-redux";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { generateYAxisTicks } from "../../../../../util/helpers";
import PatientLoader from "../../../../common/PatientLoader";
import DateRangeComponent from "../DateRangeComponent";
import { NoAssessments } from "../FlaggedJournals";
import AssessmentsOverview from "./AssessmentsOverview";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );

  export const GADAssessment = ({
    setCheckinTab = null,
    size = "7",
    showHeading = true,
  })=>{
    const { assessmentsLoading, assessmentsData } = useSelector(
        (state) => state.assessment
      );
    
      const { singlePatientData } = useSelector((state) => state.patient);
    
      function normailzeData(data) {
        const formattedData = {};
        data?.forEach((item) => {
          const date = moment(item?.created).format("MMM DD");
          if (date in formattedData) {
            formattedData[date] += item?.score;
          } else {
            formattedData[date] = item?.score;
          }
        });
        return formattedData;
      }

      function generateXAxisData(arr1) {
        arr1 = Object.keys(arr1);
        const res = [...new Set([...arr1])];
        return res;
      }

  const [labels, setLabels] = useState([]);
  const [gad7, setGad7] = useState([]);
  const [transparentAxis, setTransparentAxis] = useState([]);
  const [noData, setNoData] = useState(false);
  const [globalMinima, setGlobalMinima] = useState(0);
  const [globalMaxima, setGlobalMaxima] = useState(40);

  // const [yAxisLookup, setYAxisLookup] = useState({
  //   0: "😄 Great",
  //   5: "😁 Good",
  //   10: "🙂 Okay",
  //   15: "😢 Bad",
  //   20:"😭 Awful",
  // });
  const [yAxisLookup, setYAxisLookup] = useState({
    0: "Minimal",
    5: "Mild",
    10: "Moderate",
    15: "Severe",
    30:"",
  });

  const paddingData = (xAxis, dataArray) => {
    //*Padding data to have null values where dates don't match up
    const temp = xAxis.map((item) => {
      if (item in dataArray) {
        return dataArray[item];
      }
      return null;
    });
    return temp;
  };
  useEffect(() => {
    if (!assessmentsLoading) {
        if (assessmentsData) {
          
          const condition1 =
            "GAD-7" in assessmentsData && assessmentsData["GAD-7"]?.length !== 0;
          if (!condition1) {
            setNoData(true);
            return;
          }
          setNoData(false);
          
          let data1 = normailzeData(assessmentsData["GAD-7"]);
          
          const xAxis = generateXAxisData(data1);
  
          //Padding data to have null values where dates don't match up
          
          data1 = paddingData(xAxis, data1);
          setGad7(data1);
         
  
          const maxima = Math.max(...[...data1,]) + 10;
          setGlobalMaxima(maxima);
          setTransparentAxis([0, maxima]);
          setLabels([...xAxis]);
        }
      }
  }, [assessmentsLoading, assessmentsData]);
  let chartData = {}
  chartData = {
    labels,
    datasets: [
      {
        label: "GAD 7",
        data: gad7,
        borderColor: "#4339F2",
        backgroundColor: "#4339F2",
      },
      {
        label: "",
        data: transparentAxis,
        borderColor: "transparent",
        backgroundColor: "transparent",
      },
    ],
  };
  const options = {
    responsive: true,
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        min: 0,
        max: 30,
        ticks: {
          stepSize:5,
          // maxTicksLimit: 15,
          callback: (value) => {
            return yAxisLookup[value];
          },
        },
      },
    },
    plugins: {
      legend: {
        labels: {
          usePointStyle: true,
          boxWidth: 12,
          boxHeight: 10,
          useBorderRadius: true,
          borderRadius: 100,
          pointStyle: "circle",
          family: "'DM Sans'",
        },
        position: "top",
        align: "start",
      },
      title: {
        display: false,
      },
    },
  };
  return (
    <CardLayout
      className={`col-sm-12 col-md-${size} col-lg-${size}`}
      style={{
        border: "8px solid transparent",
        boxSizing: "border-box",
        backgroundClip: "padding-box",
      }}
    >
      <div className="container-fluid p-4">
        <div className="d-flex justify-content-between mb-4 mt-2">
          {showHeading && (
            <label style={{ fontSize: "1.3rem" }}>GAD-7 Assessment Overview</label>
          )}

          {setCheckinTab !== null ? (
            <small
              onClick={() => {
                setCheckinTab();
              }}
              style={{
                color: "#395e9d",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              View more {">"}
            </small>
          ) : (
            <></>
          )}
        </div>
        {noData ? (
          <NoAssessments
            text={`${
              singlePatientData?.first_name || "Patient"
            } has not taken this assessment!`}
            show_link={false}
          />
        ) : (
          <>
            {assessmentsLoading ? (
              <PatientLoader showText={false} />
            ) : (
              <div className="container-fluid">
                <Line options={options} data={chartData} />
              </div>
            )}
          </>
        )}
      </div>
    </CardLayout>
  );
  }